import React from 'react'
import { ButtonBase, withStyles } from '@material-ui/core'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { FormattedMessage } from 'react-intl'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import classNames from 'classnames'
import { useHistory } from 'react-router'

const CONTRACT: string = 'contract'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			detailsContainer: {
				display: 'flex',
				flexDirection: 'column',
				width: '100%'
			},
			detailButton: {
				marginTop: 8
			},
			detailDiv: {
				display: 'flex',
				alignItems: 'flex-start',
				width: '100%',
				flexDirection: 'column'
			}
		}
	)
)

const Accordion = withStyles({
	root: {
		marginTop: 21,
		boxShadow: 'none',
		width: '100%',
		padding: '8px 16px',
		marginRight: '.5rem',
		marginLeft: '.5rem',
		'&:before': {
			display: 'none'
		},
		'&$expanded': {
			margin: '21px .5rem 0px .5rem'
		}
	},
	expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
	root: {
		padding: 0,
		'&$expanded': {
			minHeight: 0
		}
	},
	content: {
		margin: 0,
		'&$expanded': {
			margin: 0
		}
	},
	expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles({
	root: {
		padding: 0
	}
})(MuiAccordionDetails)

interface AcceptingProps {
	contracts: ContractsModel[],
	selectedContract: ContractsModel,
}

type AccordionHeaderProps = AcceptingProps

const AccordionHeader: React.FC<AccordionHeaderProps> = (
	{
		contracts,
		selectedContract
	}
) => {
	const classes = useStyle()
	const history = useHistory()

	const [expanded, setExpanded] = React.useState(false)

	const handleChange = () => {
		setExpanded(!expanded)
	}

	const onClickContract = (contractId: string) => {
		setExpanded(!expanded)
		history.push(
			{
				search: `?${CONTRACT}=${contractId}`
			}
		)
	}

	const menuTextClass = classNames(
		classes.text9_opacity,
		classes.medium
	)

	const menuTitleClass = classNames(
		classes.text8,
		classes.semiBold,
		classes.colorBlue
	)

	return (
		<Accordion expanded={expanded} onChange={handleChange}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
			>
				<div>
					<span className={menuTitleClass}>
						<FormattedMessage
							id={`dashboard.contracts.type.${selectedContract.type}`}
							defaultMessage="Appartement"
							description="Contract type"
						/>
					</span>
					<div>
						<span className={menuTextClass}>
						{selectedContract.address} • {selectedContract.postalCode} {selectedContract.city}
						</span>
					</div>
				</div>
			</AccordionSummary>
			<AccordionDetails>
				<div className={classes.detailsContainer}>
					{contracts.map(
						(contract, key) => (
							(contract.id !== selectedContract.id) &&
							<ButtonBase key={key} onClick={() => onClickContract(contract.id)} className={classes.detailButton}>
								<div className={classes.detailDiv}>
									<span className={menuTitleClass}>
                                        <FormattedMessage
	                                        id={`dashboard.contracts.type.${contract.type}`}
	                                        defaultMessage="Appartement"
	                                        description="Contract type"
                                        />
									</span>
									<div>
										<span className={menuTextClass}>
										    {contract.address} • {contract.postalCode} {contract.city}
										</span>
									</div>
								</div>
							</ButtonBase>
						)
					)}
				</div>
			</AccordionDetails>
		</Accordion>
	)
}

export default AccordionHeader